<div [formGroup]="form">
  <p class="router-delivery-title">Velg levering av ruter</p>
  <div class="delivery-container">
    <app-ice-select-box
      label="Send i posten"
      radioTestId="send-in-post-input"
      [control]="form.controls.deliverySelection"
      [disabled]="!canSellRouterWithLogistics"
      [infoText]="noAvailableRoutersForSendInPostText"
      [value]="MbbDeliveryOptions.SendRouterInPost"
    />
    <app-ice-select-box
      label="Selg i butikk"
      radioTestId="sell-in-store-input"
      [control]="form.controls.deliverySelection"
      [disabled]="!canSellRouterInStore"
      [infoText]="noAvailableRoutersForSellInStoreText"
      [value]="MbbDeliveryOptions.SellInStore"
    />
    <app-ice-select-box
      label="Selg bare abonnement"
      radioTestId="already-own-router-input"
      [control]="form.controls.deliverySelection"
      [disabled]="!canSellSubscriptionOnly"
      [infoText]="isSubscriptionOnlyBlockedByBinding ? 'MBB-abonnement med avtaletid må selges med ruter' : ''"
      [value]="MbbDeliveryOptions.AlreadyOwnRouter"
    >
      @if (form.controls.deliverySelection.value === MbbDeliveryOptions.AlreadyOwnRouter && canSellSubscriptionOnly) {
        <div class="icc-container">
          <p class="sim-delivery-title">Hvordan får kunden SIM-kortet?</p>
          <div class="sim-delivery-options">
            <app-ice-radio-button
              forId="mbb-sim-delivery-in-store"
              formControlName="simDelivery"
              label="Levert i butikk"
              ngDefaultControl
              testId="sim-delivery-in-store"
              [isBoxVersion]="true"
              [value]="SimCardDelivery.InStore"
            />
            <app-ice-radio-button
              forId="mbb-sim-delivery-by-mail"
              formControlName="simDelivery"
              label="Send i posten"
              ngDefaultControl
              testId="sim-delivery-by-mail"
              [isBoxVersion]="true"
              [value]="SimCardDelivery.ByMail"
            />
          </div>
          @if (form.controls.simDelivery.value === SimCardDelivery.InStore) {
            <app-ice-input-field
              formControlName="icc"
              label="Registrer SIM-kort"
              ngDefaultControl
              ngxsFormPath="formState.mbbForm"
              placeholder="Scan eller skriv inn SIM-nummeret"
              textTestId="icc-input"
              [errorText]="getSimCardErrorTexts(iccField.errors, SimCardType.Mbb)"
              [inputWidth]="'large'"
              [maxlength]="20"
              [minlength]="19"
            />
            @if ((iccField.statusChanges | async) === FormStatus.PENDING || iccField.status === FormStatus.PENDING) {
              <app-spinner />
            }
          }
        </div>
      }
    </app-ice-select-box>
  </div>
</div>

<div class="routers-container">
  @switch (form.controls.deliverySelection.value) {
    @case (MbbDeliveryOptions.SellInStore) {
      <p class="router-delivery-title">Velg ruter type</p>
      <app-mbb-router
        [mbbProduct]="mbbProduct"
        [mbbRouters]="mbbRouters"
        [warehouseState]="warehouseState"
        (isInvalid)="onMbbRouterIsInvalid($event)"
        (mbbRouterChange)="mbbRouterChange.emit($event)"
      />
      <app-mbb-router-details
        [mbbProduct]="mbbProduct"
        (isInvalid)="onMbbRouterDetailsAreInvalid($event)"
        (mbbRouterDetailsIccChanged)="mbbRouterDetailsIccChanged.emit($event)"
        (mbbRouterDetailsImeiChanged)="mbbRouterDetailsImeiChanged.emit($event)"
      />
    }
    @case (MbbDeliveryOptions.SendRouterInPost) {
      @if (routersAvailableForLogistics.length > 0) {
        <p class="router-delivery-title">Velg ruter type</p>
        <app-mbb-router
          [mbbProduct]="mbbProduct"
          [mbbRouters]="routersAvailableForLogistics"
          [warehouseState]="warehouseState"
          (isInvalid)="onMbbRouterIsInvalid($event)"
          (mbbRouterChange)="mbbRouterChange.emit($event)"
        />
      }
    }
    @case (MbbDeliveryOptions.AlreadyOwnRouter) {}
  }
</div>
